module.exports = __webpack_public_path__ + "img/my-expenses-2.266ecb76.svg";